import type { DiscountListItemType } from "@/features/cart/types/discount.type";
import { GET } from "@/lib/methods";

export const getDiscountsInfo = ({
  params,
  code,
  client = false,
}: {
  params?: RequestInit;
  code: string;
  client?: boolean;
}) => {
  const requestParams = {
    next: client
      ? {}
      : {
          tags: ["discounts-info", code],
          revalidate: 3600,
        },
    ...params,
  };

  const res = GET<DiscountListItemType>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/coupons/phrase/${code}`,
    params: requestParams,
  });

  return res;
};
